// extracted by css-extract-rspack-plugin
export default {"root":"VlXmcfR82fj67KzLZL_fY","colorSquare":"_1MnCvx9Wt6VDFMYAerDhSm","title":"_1hUc-9Da7Rkyya9rBpN7pT","description":"kzXaEeYArCn01nptKMLdt"};